import * as React from "react";
import {
    List, Datagrid, TextField, EditButton, ShowButton, Edit, Show,
    SimpleForm, SimpleShowLayout, TextInput, SelectInput, NumberInput,
    DateField, Filter, DeleteButton
} from 'react-admin';

const WorkRecordFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索设备编号" source="key" alwaysOn />
        <SelectInput label="状态" source="Status" choices={[
            { id: 'in_progress', name: '作业中' },
            { id: 'completed', name: '已完成' },
        ]} />
    </Filter>
);

export const AgriWorkRecordList = props => (
    <List {...props} filters={<WorkRecordFilter />} title="作业记录管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="DemandId" label="需求ID" />
            <TextField source="ProviderId" label="服务主体ID" />
            <TextField source="DeviceId" label="设备编号" />
            <TextField source="WorkType" label="作业类型" />
            <DateField source="StartTime" label="开始时间" showTime />
            <DateField source="EndTime" label="结束时间" showTime />
            <TextField source="Duration" label="时长(分钟)" />
            <TextField source="AreaCompleted" label="作业面积(亩)" />
            <TextField source="Status" label="状态" />
            <TextField source="Rating" label="评分" />
            <EditButton />
            <ShowButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const AgriWorkRecordShow = props => (
    <Show {...props} title="作业记录详情">
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="DemandId" label="需求ID" />
            <TextField source="ProviderId" label="服务主体ID" />
            <TextField source="DeviceId" label="设备编号" />
            <TextField source="WorkType" label="作业类型" />
            <DateField source="StartTime" label="开始时间" showTime />
            <DateField source="EndTime" label="结束时间" showTime />
            <TextField source="Duration" label="时长(分钟)" />
            <TextField source="AreaCompleted" label="作业面积(亩)" />
            <TextField source="Status" label="状态" />
            <TextField source="Rating" label="评分" />
            <TextField source="Comment" label="评价" />
            <TextField source="ReportUrl" label="报告地址" />
            <DateField source="RatingTime" label="评价时间" showTime />
            <DateField source="CreateTime" label="创建时间" showTime />
        </SimpleShowLayout>
    </Show>
);

export const AgriWorkRecordEdit = props => (
    <Edit {...props} title="编辑作业记录">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="DeviceId" label="设备编号" />
            <TextInput source="WorkType" label="作业类型" />
            <NumberInput source="Duration" label="时长(分钟)" />
            <NumberInput source="AreaCompleted" label="作业面积(亩)" />
            <TextInput source="ReportUrl" label="报告URL" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 'in_progress', name: '作业中' },
                { id: 'completed', name: '已完成' },
            ]} />
            <NumberInput source="Rating" label="评分" />
            <TextInput source="Comment" label="评价" />
        </SimpleForm>
    </Edit>
);
